import appApi from '../../../../../api/app-api';
import { CheckType } from '../../../../../api/types/reports/accountant/check.type';
import { ChecksSideBarFilterType } from '../side-bar/checks-side-bar-filter.type';
import { displayErrorText } from '../../../../../api/errors/api-error-codes';
import { toast } from 'react-toastify';

export const getReportCheckOperation = async (
  filters: ChecksSideBarFilterType,
  offset: number,
  limit: number,
  setData: (data: CheckType[]) => any,
  setTotal: (total: number) => any,
  setLoading: (loading: boolean) => any,
) => {
  try {
    setLoading(true);
    const trimmedCheckReferenceId = filters.checkReferenceId?.trim();
    const res = await appApi.getChecksReport({
      branchIds: filters.branchIds ?? [],
      paymentCollectionStartDate: filters.paymentCollectionStartDate ?? null,
      paymentCollectionEndDate: filters.paymentCollectionEndDate ?? null,
      checkRepaymentStartDate: filters.checkRepaymentStartDate ?? null,
      checkRepaymentEndDate: filters.checkRepaymentEndDate ?? null,
      checkStatuses: filters.checkStatuses ?? [],
      docNumber: filters.docNumber ?? null,
      checkReferenceId: trimmedCheckReferenceId
        ? trimmedCheckReferenceId
        : null,
      offset,
      limit,
    });
    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return;
    }
    setData(res.data.body.data ?? []);
    setTotal(res.data.body.total ?? 0);
    setLoading(false);
  } catch (e) {
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
    setLoading(false);
  }
};
